<div *ngIf="mode === editMode.CREATE">
  <app-tag-list-add
    [tags]="tags"
    [filteredTags]="this.filteredTags"
    [parentName]="this.parentName"
    [customerBillerId]="this.customerBillerId"
    [subAccountId]="this.subAccountId"
    [closeAction]="this.closeAction"
    [form]="this.form"
    [edit]="editClicked"
    [addCustomTag]="addCustomTag"
    [cancel]="cancelAdding"
    [checkChange]="checkTagChange"
  ></app-tag-list-add>
</div>

<div *ngIf="mode === editMode.EDIT">
  <app-tag-list-edit
    [editForm]="editForm"
    [tag]="editedTag"
    [save]="updateTag"
    [delete]="delete"
    [cancel]="cancelEditing"
  ></app-tag-list-edit>
</div>
